<template>
    <div v-if="lastUpdated" class="widget-last-updated">
        {{ $t('dashboard.widgets.lastUpdated') }}:
        <span class="widget-last-updated-time" v-text="time"></span>
    </div>
</template>

<script>
import { getTimeNoSecondsFormat } from '../../../common/helpers';
import format from 'date-fns/format';

export default {
    name: 'WidgetLastUpdated',

    props: {
        lastUpdated: {
            type: Date,
            required: false,
            default: null,
        },
    },

    computed: {
        time() {
            if (this.lastUpdated instanceof Date) {
                return format(this.lastUpdated, getTimeNoSecondsFormat());
            }

            return '?';
        },
    },
};
</script>
